import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { GlobalToasterService } from 'app/services/global-toaster.service';

@Component({
  selector: 'app-global-toaster',
  standalone: true,
  imports: [CommonModule, MatIconModule],
  templateUrl: './global-toaster.component.html',
})
export class GlobalToasterComponent {
  constructor(public globalToasterSerive: GlobalToasterService) {}

  closeToaster(){
    this.globalToasterSerive.setToaster({
      show: false,
      message: '',
    })
  }
}
